<template>
  <v-dialog v-model="profileInfoDialog" width="800">
    <v-card v-if="$vuetify.breakpoint.smAndUp">
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!-- {{ $t("general.about1") }} -->
        <span class="display-1 text-uppercase font-weight-bold">{{
          $t("infoDialogs.private.profile.Title")
        }}</span>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          :title="$t('infoDialogs.private.profile.Close window')"
          class="ma-2"
          outlined
          icon
          large
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title">
          {{ $t("infoDialogs.private.profile.PageDescription") }}.
        </p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row>
          <v-col md="4">
            <span class="body-1 text--primary font-weight-bold"
              >{{ $t("infoDialogs.private.profile.PageActionsOne") }}:</span
            >
          </v-col>
          <v-col md="8">
            <span class="body-1 text--primary"
              >{{
                $t(
                  "infoDialogs.private.profile.In the grey box below, you define what the other users can see (Name, Country and Gender)"
                )
              }}.</span
            >
          </v-col>
          <v-col md="12" class="ma-o pa-0 pl-5 pr-5">
            <v-expansion-panels focusable hover>
              <v-expansion-panel class="grey lighten-1 mt-5 mb-3">
                <v-expansion-panel-header class="title">
                  <div style="display:flex;">
                    <span>{{ $t("infoDialogs.private.profile.Example") }}</span>
                    <span class="pl-5">(</span>
                    <span
                      v-if="DisplayName == false"
                      class="ma-0 pa-0 pl-2 red--text"
                    >
                      {{ $t("infoDialogs.private.profile.Name") }}</span
                    >
                    <span
                      v-if="DisplayName == true"
                      class="ma-0 pa-0 pl-2 green--text"
                    >
                      {{ $t("infoDialogs.private.profile.Name") }}</span
                    >,
                    <span
                      v-if="DisplayCountry == false"
                      class="ma-0 pa-0 pl-2 red--text"
                    >
                      {{ $t("infoDialogs.private.profile.Country") }}</span
                    >
                    <span
                      v-if="DisplayCountry == true"
                      class="ma-0 pa-0 pl-2 green--text"
                    >
                      {{ $t("infoDialogs.private.profile.Country") }}</span
                    >,
                    <span
                      v-if="DisplayGender == false"
                      class="ma-0 pa-0 pl-2 red--text"
                    >
                      {{ $t("infoDialogs.private.profile.Gender") }}</span
                    >
                    <span
                      v-if="DisplayGender == true"
                      class="ma-0 pa-0 pl-2  pr-2 green--text"
                    >
                      {{ $t("infoDialogs.private.profile.Gender") }}</span
                    >
                    <span class="pl-2">)</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-2">
                  <v-row>
                    <v-col md="4" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                      <p
                        v-if="DisplayName == false"
                        class="pb-0 mb-0 pt-5 pb-2"
                      >
                        {{
                          $t(
                            "infoDialogs.private.profile.Name are NOT displayed"
                          )
                        }}
                      </p>
                      <p
                        v-if="DisplayName == true"
                        class="pb-0 mb-0 pt-5 pb-2 green--text"
                      >
                        {{
                          $t("infoDialogs.private.profile.Name are displayed")
                        }}d
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          v-model="DisplayName"
                          :label="
                            $t('infoDialogs.private.profile.Display Name')
                          "
                        ></v-switch
                      ></span>
                    </v-col>
                    <v-col md="4" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                      <p
                        v-if="DisplayCountry == false"
                        class="pb-0 mb-0 pt-5 pb-2"
                      >
                        {{
                          $t(
                            "infoDialogs.private.profile.Country are NOT displayed"
                          )
                        }}
                      </p>
                      <p
                        v-if="DisplayCountry == true"
                        class="pb-0 mb-0 pt-5 pb-2 green--text"
                      >
                        {{
                          $t(
                            "infoDialogs.private.profile.Country are displayed"
                          )
                        }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          v-model="DisplayCountry"
                          :label="
                            $t('infoDialogs.private.profile.Display Country')
                          "
                        ></v-switch
                      ></span>
                    </v-col>
                    <v-col md="auto" class="mt-0 pt-0 mb-0 pb-0 ml-3">
                      <p
                        v-if="DisplayGender == false"
                        class="pb-0 mb-0 pt-5 pb-2"
                      >
                        {{
                          $t(
                            "infoDialogs.private.profile.Gender are NOT displayed"
                          )
                        }}
                      </p>
                      <p
                        v-if="DisplayGender == true"
                        class="pb-0 mb-0 pt-5 pb-2 green--text"
                      >
                        {{
                          $t("infoDialogs.private.profile.Gender are displayed")
                        }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          v-model="DisplayGender"
                          :label="
                            $t('infoDialogs.private.profile.Display Gender')
                          "
                        ></v-switch
                      ></span>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <!-- <v-col md="4">
            <span class="body-1 text--primary font-weight-bold"
              >{{ $t("infoDialogs.private.profile.Obligatory fields") }}:</span
            >
          </v-col>
          <v-col md="8">
            <span class="body-1 text--primary"
              >##Need work, Define which fields that cant be empty</span
            >
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>
    <!--Phone-->
    <v-card v-else>
      <!--Title and close-->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{
          $t("infoDialogs.private.profile.Title")
        }}</span>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          :title="$t('profile.general.Close Window')"
          class="ma-2"
          outlined
          icon
          large
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="ma-0 pa-0">
          <!--Description-->
          <v-col cols="12" class="py-0">
            <p class="pr-5 text--primary title">
              {{ $t("infoDialogs.private.profile.PageDescription") }}.
            </p>
          </v-col>
          <v-divider></v-divider>
          <v-divider></v-divider>
          <!--Box description-->
          <v-col cols="12" class="py-0">
            <span class="body-1 text--primary font-weight-bold"
              >I boksen nedenfor hvilket informasjon som skal vises.</span
            >
          </v-col>
          <!--Privacy setting-->
          <v-col cols="12" class="py-0">
            <v-expansion-panels focusable hover>
              <v-expansion-panel class="grey lighten-1 mt-5 mb-3">
                <v-expansion-panel-header class="title">
                  <div style="display:flex;">
                    <span class="pl-0">(</span>
                    <span
                      v-if="DisplayName == false"
                      class="ma-0 pa-0 pl-2 red--text"
                    >
                      {{ $t("infoDialogs.private.profile.Name") }}</span
                    >
                    <span
                      v-if="DisplayName == true"
                      class="ma-0 pa-0 pl-2 green--text"
                    >
                      {{ $t("infoDialogs.private.profile.Name") }}</span
                    >,
                    <span
                      v-if="DisplayCountry == false"
                      class="ma-0 pa-0 pl-2 red--text"
                    >
                      {{ $t("infoDialogs.private.profile.Country") }}</span
                    >
                    <span
                      v-if="DisplayCountry == true"
                      class="ma-0 pa-0 pl-2 green--text"
                    >
                      {{ $t("infoDialogs.private.profile.Country") }}</span
                    >,
                    <span
                      v-if="DisplayGender == false"
                      class="ma-0 pa-0 pl-2 red--text"
                    >
                      {{ $t("infoDialogs.private.profile.Gender") }}</span
                    >
                    <span
                      v-if="DisplayGender == true"
                      class="ma-0 pa-0 pl-2  pr-2 green--text"
                    >
                      {{ $t("infoDialogs.private.profile.Gender") }}</span
                    >
                    <span class="pl-2">)</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-2">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <p v-if="DisplayName == false" class="pb-0 mb-0 pt-3">
                        {{
                          $t(
                            "infoDialogs.private.profile.Name are NOT displayed"
                          )
                        }}
                      </p>
                      <p
                        v-if="DisplayName == true"
                        class="pb-0 mb-0 pt-3 green--text"
                      >
                        {{
                          $t("infoDialogs.private.profile.Name are displayed")
                        }}d
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          v-model="DisplayName"
                          :label="
                            $t('infoDialogs.private.profile.Display Name')
                          "
                        ></v-switch
                      ></span>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <p v-if="DisplayCountry == false" class="pb-0 mb-0">
                        {{
                          $t(
                            "infoDialogs.private.profile.Country are NOT displayed"
                          )
                        }}
                      </p>
                      <p
                        v-if="DisplayCountry == true"
                        class="pb-0 mb-0 green--text"
                      >
                        {{
                          $t(
                            "infoDialogs.private.profile.Country are displayed"
                          )
                        }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          v-model="DisplayCountry"
                          :label="
                            $t('infoDialogs.private.profile.Display Country')
                          "
                        ></v-switch
                      ></span>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <p v-if="DisplayGender == false" class="pb-0 mb-0 pb-2">
                        {{
                          $t(
                            "infoDialogs.private.profile.Gender are NOT displayed"
                          )
                        }}
                      </p>
                      <p
                        v-if="DisplayGender == true"
                        class="pb-0 mb-0 pb-2 green--text"
                      >
                        {{
                          $t("infoDialogs.private.profile.Gender are displayed")
                        }}
                      </p>
                      <span
                        ><v-switch
                          class="ma-0 pa-0"
                          v-model="DisplayGender"
                          :label="
                            $t('infoDialogs.private.profile.Display Gender')
                          "
                        ></v-switch
                      ></span>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <!--Form Description-->
          <v-col cols="12" class="py-0"> </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data() {
    return {
      // Define the dialog v-model that we are using
      profileInfoDialog: false,
      // Define if to display Name or not
      DisplayName: false,
      // Define if to display Country or not
      DisplayCountry: false,
      // Define if to display Gender or not
      DisplayGender: false
    };
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.profileInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.profileInfoDialog = false;
    }
  }
};
</script>
